module.exports = __webpack_public_path__ + "media/assets/images/curation/twitter-99566af517d063a7c97070b3cd3a80c0.svg";